<div class="login">
  <form class="login__form login-form"
        name="loginForm"
        (ngSubmit)="onSubmitClick(f)"
        #f="ngForm">

    <!-- Заголовок формы -->
    <div class="login-form__head">
      <!--<img class="login-form__logo" [src]="'assets/img/pit-common/logo.png'">-->
      <!-- <div class="login-form__separator"></div>-->
      <!--<h1 class="login-form__title">ОСНОВА</h1>-->
    </div>


    <!-- Основное тело формы с полями -->
    <div class="login-form__body">
      <h3 class="login-form__subtitle">Вход в систему</h3>

      <div class="form-row">
        <label class="control">
          <input class="control__field field field--full"
                 type="text"
                 name="username"
                 ngModel #username="ngModel"
                 placeholder="логин" required>
        </label>
        <div [hidden]="username.valid || username.untouched" class="login__notice  login__notice--error">
          Не указан логин
        </div>
      </div>

      <div class="form-row">
        <label class="control">
          <input class="control__field field field--full"
                 type="password"
                 name="password"
                 ngModel #password="ngModel"
                 placeholder="пароль" required>
        </label>
        <div [hidden]="password.valid || password.untouched" class="login__notice  login__notice--error">
          Не указан пароль
        </div>
      </div>


      <div class="login__details" *ngIf="f.submitted && !isValid">
        <div class="login__notice  login__notice--error">
          {{loginErrorMsg}}
        </div>
      </div>

    </div>



    <div class="login-form__foot">
      <button class="login-form__submit  btn  btn--accent" type="submit">Войти</button>

      <ul class="login-form__links">
        <li>
          <a class="link" (click)="onForgotPasswordClick()">Забыли пароль?</a>
        </li>
        <li>
          <a class="link" (click)="onRegisterClick()">Заявка на подключение</a>
        </li>
      </ul>
    </div>

  </form>
</div>

